import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagartaxifare() {



const cardData = {
  keyword: "Pune to Sambhaji Nagar Taxi Fare",
  heading: "Lotus Cab: Pune to Sambhaji Nagar Taxi Fare",

  headingDescription:
    "Lotus Cab offers transparent and competitive Pune to Chhatrapati Sambhaji Nagar taxi fare for one-way and round-trip travel. Whether you are planning a family visit, corporate trip, pilgrimage, or leisure tour, our well-maintained sedan and SUV fleet ensures comfortable long-distance travel. The Pune to Sambhaji Nagar (Aurangabad) route is approximately 230–240 km and is well-connected via smooth highways, making road travel convenient and efficient. We provide clear per-kilometer pricing, detailed cab charges breakdown, and flexible booking options without hidden costs. All vehicles are air-conditioned, sanitized, and driven by experienced chauffeurs familiar with highway routes and tourist destinations. With doorstep pickup anywhere in Pune and easy online fare estimation support, Lotus Cab makes your Pune to Sambhaji Nagar taxi travel affordable, safe, and stress-free.",

  top: "Top Places to Visit in Sambhaji Nagar with Lotus Cab",

  topPlaces: [
    {
      title: "Ajanta Caves",
      description:
        "Ajanta Caves are UNESCO World Heritage rock-cut Buddhist monuments famous for ancient murals and sculptures. Travelers often book Pune to Sambhaji Nagar taxi fare packages to explore this historical masterpiece comfortably. The caves are located around 100 km from the city and require a reliable long-distance vehicle. Lotus Cab provides smooth highway travel with professional drivers ensuring safe round-trip journeys."
    },
    {
      title: "Ellora Caves",
      description:
        "Ellora Caves feature stunning Hindu, Buddhist, and Jain temples carved into rock, including the iconic Kailasa Temple. Visitors prefer booking AC taxi from Pune to Sambhaji Nagar for comfortable long drives. Spacious seating and luggage support make travel convenient for families and groups."
    },
    {
      title: "Bibi Ka Maqbara",
      description:
        "Often called the 'Mini Taj Mahal,' Bibi Ka Maqbara is a prominent attraction in Sambhaji Nagar. Tourists frequently combine this visit with Ajanta-Ellora tours. Lotus Cab ensures punctual drop and flexible waiting time."
    },
    {
      title: "Daulatabad Fort",
      description:
        "Daulatabad Fort is an impressive medieval fortress known for its strategic design and panoramic views. Travelers booking Pune to Aurangabad taxi fare services enjoy comfortable transport to this historic site."
    },
    {
      title: "Grishneshwar Temple",
      description:
        "Grishneshwar Temple is one of the 12 Jyotirlingas, attracting pilgrims year-round. Our affordable cab service ensures smooth pilgrimage travel with safe highway driving."
    },
    {
      title: "Panchakki",
      description:
        "Panchakki is a historical water mill and peaceful garden area ideal for family visits. Comfortable sedan and SUV travel ensures relaxed sightseeing."
    },
    {
      title: "Siddharth Garden",
      description:
        "Siddharth Garden is a popular leisure spot for families and children. Lotus Cab provides comfortable AC vehicles suitable for local city tours."
    },
    {
      title: "Jayakwadi Dam",
      description:
        "Jayakwadi Dam is a scenic attraction near Sambhaji Nagar offering beautiful sunset views. Travelers often prefer round-trip taxi booking for convenient travel."
    }
  ],

  services: [
    {
      name: "Pune to Chhatrapati Sambhaji Nagar Taxi Fare",
      description:
        "Get transparent Pune to Chhatrapati Sambhaji Nagar taxi fare with clear per-kilometer pricing and detailed cab charges breakdown. Our fare includes professional driver service and well-maintained AC vehicles suitable for long-distance travel. Ideal for family trips, pilgrimages, and business visits. Flexible one-way and round-trip fare options available. No hidden charges with upfront pricing transparency."
    },
    {
      name: "Pune to Aurangabad Taxi Fare",
      description:
        "Affordable Pune to Aurangabad taxi fare for sedan and SUV categories with competitive per km rates. Suitable for Ajanta, Ellora, and temple tours. Professional drivers ensure safe highway travel."
    },
    {
      name: "One Way Cab Fare Pune to Sambhaji Nagar",
      description:
        "Book one-way cab fare from Pune to Sambhaji Nagar and pay only for single-side travel. Ideal for travelers planning extended stays. Transparent billing provided."
    },
    {
      name: "Round Trip Taxi Fare Pune to Sambhaji Nagar",
      description:
        "Convenient round-trip taxi fare packages with flexible return schedules. Suitable for weekend tours and pilgrimage travel."
    },
    {
      name: "Per Km Rate Pune to Sambhaji Nagar",
      description:
        "Clear per kilometer rate structure for sedan and SUV categories. Easy fare calculation before booking with transparent cost estimation."
    },
    {
      name: "Affordable Cab Pune to Sambhaji Nagar",
      description:
        "Budget-friendly taxi service with competitive pricing and reliable travel experience."
    },
    {
      name: "SUV Fare Pune to Sambhaji Nagar",
      description:
        "Spacious SUV taxi options with comfortable seating and luggage support for group travel."
    },
    {
      name: "Online Fare Calculator Pune to Sambhaji Nagar",
      description:
        "Estimate your travel cost instantly using our online fare calculator and book with confidence."
    }
  ],

  tableData: [
    ["Pune to Chhatrapati Sambhaji Nagar Taxi Fare", "Pune to Aurangabad Taxi Fare"],
    ["One Way Cab Fare Pune to Sambhaji Nagar", "Round Trip Taxi Fare Pune to Sambhaji Nagar"],
    ["Per Km Rate Pune to Sambhaji Nagar", "Affordable Cab Pune to Sambhaji Nagar"],
    ["SUV Fare Pune to Sambhaji Nagar", "Luxury Taxi Charges Pune to Sambhaji Nagar"],
    ["Online Fare Calculator Pune to Sambhaji Nagar", "AC Taxi Pune to Sambhaji Nagar"]
  ],

  whychoose: [
    { WhyChooseheading: "Transparent Fare Structure", WhyChoosedescription: "Clear per-kilometer pricing with complete breakdown of charges and no hidden fees." },
    { WhyChooseheading: "Experienced Highway Drivers", WhyChoosedescription: "Professional chauffeurs experienced in long-distance travel ensure safe journeys." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Air-conditioned sedan and SUV fleet maintained for maximum comfort." },
    { WhyChooseheading: "Flexible One-Way & Round Trip", WhyChoosedescription: "Choose one-way drop or round-trip package based on your travel needs." },
    { WhyChooseheading: "Affordable Pricing", WhyChoosedescription: "Competitive cab charges suitable for family and business travel." },
    { WhyChooseheading: "Online Fare Estimation", WhyChoosedescription: "Instant fare calculator support for budget planning before booking." },
    { WhyChooseheading: "Doorstep Pickup in Pune", WhyChoosedescription: "Convenient pickup from home, hotel, or airport anywhere in Pune." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock assistance for booking and travel coordination." }
  ]
};

const faqData = [
  { question: "How much is Pune to Sambhaji Nagar taxi fare?", answer: "Fare depends on vehicle type and trip type, calculated on per-km basis with transparent billing." },
  { question: "Is one-way taxi available?", answer: "Yes, affordable one-way cab fare options available." },
  { question: "Are SUV vehicles available?", answer: "Yes, spacious SUV options available for group travel." },
  { question: "Is online fare calculator available?", answer: "Yes, you can estimate fare before booking." },
  { question: "Is AC taxi provided?", answer: "Yes, fully air-conditioned vehicles are provided." },
  { question: "Are drivers experienced?", answer: "Yes, trained drivers with highway experience." },
  { question: "Is round-trip booking possible?", answer: "Yes, flexible return options available." },
  { question: "Are toll charges included?", answer: "Toll and parking are calculated transparently as applicable." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate travel bookings are available." },
  { question: "Is 24/7 support available?", answer: "Yes, customer support available anytime." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Anil Deshmukh",
    feedback:
      "Booked Pune to Sambhaji Nagar taxi for family pilgrimage. Transparent fare and very comfortable journey. Driver was professional and punctual.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Patil",
    feedback:
      "Used Lotus Cab for Ajanta-Ellora trip. Pricing was clear and vehicle was clean. Smooth and safe highway travel.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable Pune to Aurangabad taxi fare service for business travel. Professional driver and timely pickup.",
    rating: 5
  }
];















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sambhaji Nagar Taxi Fare",
  "image": "https://lotuscab.com/assets/images/pune-to-sambhaji-nagar-taxi.jpg", 
  "description": "Lotus Cab provides taxi services from Pune to Chhatrapati Sambhaji Nagar (Aurangabad) with transparent fare structure. Options include one-way and round-trip cabs, SUV and luxury taxis, AC taxis, and per km rates. Use our online fare calculator for accurate Pune to Sambhaji Nagar cab pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-sambhaji-nagar-taxi-fare"
  }
};






  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Pune to Sambhaji Nagar Taxi Fare | Lotus Cab</title>
  <meta 
    name="description" 
    content="Check Pune to Sambhaji Nagar taxi fare with Lotus Cab. One-way, round-trip, SUV & luxury taxis, AC cabs, and online fare calculator for accurate pricing. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Chhatrapati Sambhaji Nagar Taxi Fare, Pune to Sambhaji Nagar Cab Charges, Pune to Aurangabad Taxi Fare, One Way Cab Fare Pune to Sambhaji Nagar, Round Trip Taxi Fare Pune to Sambhaji Nagar, Per Km Rate Pune to Sambhaji Nagar, Affordable Cab Pune to Sambhaji Nagar, SUV Fare Pune to Sambhaji Nagar, Luxury Taxi Charges Pune to Sambhaji Nagar, Online Fare Calculator Pune to Sambhaji Nagar, AC Taxi Pune to Sambhaji Nagar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosambhajinagartaxifare;